/**
 * @packageDocumentation
 * @module HackerAPI.Event.BadgeCode
 */
import { __extends } from "tslib";
import Base from "../../base/base";
import HackerAPIFetch from "../../hackerapi-fetch/hackerapi-fetch";
var BadgeCode = /** @class */ (function (_super) {
    __extends(BadgeCode, _super);
    function BadgeCode(_a) {
        var _b = _a === void 0 ? {} : _a, id = _b.id, role = _b.role, user_id = _b.user_id, userId = _b.userId, user_name = _b.user_name, name = _b.name, user_email = _b.user_email, email = _b.email, mentor_skills = _b.mentor_skills, mentorSkills = _b.mentorSkills, mentor_location = _b.mentor_location, mentorLocation = _b.mentorLocation, bio = _b.bio, avatar = _b.avatar, event_id = _b.event_id, eventId = _b.eventId, event_slug = _b.event_slug, eventSlug = _b.eventSlug, badge_codes = _b.badge_codes, badgeCodes = _b.badgeCodes;
        var _this = _super.call(this) || this;
        _this.id = id;
        /**
         * @type { string }
         */
        _this.role = role;
        _this.userId = user_id || userId;
        /**
         * @type { string }
         */
        _this.name = user_name || name;
        _this.email = user_email || email;
        _this.mentorSkills = mentor_skills || mentorSkills;
        _this.mentorLocation = mentor_location || mentorLocation;
        _this.bio = bio;
        _this.avatar = avatar;
        _this.event_id = event_id || eventId;
        _this.eventSlug = event_slug || eventSlug;
        /**
         * @type { string[] }
         */
        _this.badgeCodes = badge_codes || badgeCodes;
        return _this;
    }
    BadgeCode.fetch = function (_a, badgeCode, token) {
        var slug = _a.slug;
        return HackerAPIFetch({
            path: "/v2/events/" + slug + "/badge_code/" + badgeCode,
            method: "GET",
            token: token
        }).then(function (data) { return new BadgeCode(data); });
    };
    return BadgeCode;
}(Base));
export default BadgeCode;
//# sourceMappingURL=badge-code.js.map